export default {
    data: function () {
        return {
            restrictionTimer: null,
            autoReleaseTimer: null,
        }
    },
    computed: {
        isRestriction() {
            return this.$store.getters["auth/isRestriction"];
        },
        isUnrestricted(){
            return this.$store.getters['auth/getIsUnrestricted'];
        },
    },
    methods: {
        // 使用制限タイマー開始
        startRestrictionTimer() {
            if(this.isUnrestricted){
                this.$log.debug("使用制限タイマー無効");
                return false;
            }
            if (!this.isRestriction) {
                if (this.$store.getters["auth/isRestrictionExpired"]) {
                    // 累積時間カウント後、日付を跨いだ場合
                    this.$log.debug("累積時間カウント後、日付を跨いだので使用制限解除!!");
                    this.$store.commit("auth/resetRestrection");
                    this.$store.commit("app/setAutoReleaseRemainingTime", 0);
                } else if (this.$store.getters["auth/getRestrictionStartDateTime"]) {
                    // 使用制限後、一定期間経過後
                    this.$log.debug("使用制限後、一定期間経過後したので使用制限解除!!");
                    this.$store.commit("auth/resetRestrection");
                    this.$store.commit("app/setAutoReleaseRemainingTime", 0);
                }
                this.$log.debug("使用制限タイマー開始!!");
                this.$store.dispatch("app/startRestrictionTimer", () => {
                    this.$store.commit("auth/setRestrictionTimerStartDate");
                    this.$store.commit("auth/inclementRestrectionAccumulatedMinute");
                    const accumulatedMinute = this.$store.getters["auth/getRestrictionAccumulatedMinute"];
                    this.$log.debug("連続使用時間=>%d", accumulatedMinute);
                    if (accumulatedMinute >= process.env.VUE_APP_RESTRICTION_AVAILABLE_CONTINUATION_USAGE) {
                        this.startRestriction();
                    }
                });
            }
        },
        startRestriction() {
          this.$log.debug("使用制限開始!!");
          this.$store.commit("auth/startRestriction");
          this.$store.dispatch("app/stopRestrictionTimer");

          this.$store.dispatch("history/viewButtonEvent", {
              loginId: this.$store.getters["auth/getLoginId"],
              view: this.$store.getters["app/getCurrentView"],
              event: "使用制限開始",
              table: this.$store.getters["app/getCurrentTable"],
          });

          // 3時間後に使用制限を自動解除
          this.startAutoReleaseTimer();
        },
        startAutoReleaseTimer(delay) {
          if (this.$store.state.app.autoReleaseRemainingTime === 0) {
            this.$store.commit("app/setAutoReleaseRemainingTime", (new Date()).getTime());
          }

          this.$store.dispatch("app/startAutoReleaseTimer", {
            callback: () => {
              this.$log.debug("3時間経過したので使用制限解除!!");
              this.$store.commit("auth/resetRestrection");
              this.$store.commit("app/setAutoReleaseRemainingTime", 0);

              // 使用制限解除後に使用制限計測を再開
              this.startRestrictionTimer();
            },
            delay,
          });
        },
        // 使用制限タイマー停止
        stopRestrictionTimer() {
            this.$log.debug("使用制限タイマー停止!!");
            this.$store.dispatch("app/stopRestrictionTimer");
        },
        stopAutoReleaseTimer() {
            this.$log.debug("自動解除タイマー停止!!");
            this.$store.dispatch("app/stopAutoReleaseTimer");
        },
        // 使用制限抑止
        disableRestriction() {
            this.$log.debug("使用制限抑止開始!!");
            this.$store.commit("auth/setRestrictionDisable", true);
        },
        // 使用制限抑止解除
        enableRestriction() {
            this.$store.commit("auth/setRestrictionDisable", false);
            this.$log.debug("使用制限抑止解除!!");
        }

    }
}